import type { PostgrestError } from '@supabase/supabase-js'

/** Rows asked for per request; PostgREST may answer with fewer. */
export const ROWS_PER_REQUEST = 1000

/**
 * Reads every row a query matches, one request at a time, continuing from
 * the rows received until a request comes back empty. The query must be
 * totally ordered (end on a unique column) so pages neither overlap nor skip
 * rows.
 */
export async function fetchAllRows<T>(
  fetchPage: (
    from: number,
    to: number
  ) => PromiseLike<{ data: T[] | null; error: PostgrestError | null }>,
  errorMessage: string
): Promise<T[]> {
  const rows: T[] = []

  for (;;) {
    const from = rows.length
    const { data, error } = await fetchPage(from, from + ROWS_PER_REQUEST - 1)

    if (error) {
      throw new Error(`${errorMessage}: ${error.message}`, { cause: error })
    }

    if (!data || data.length === 0) {
      return rows
    }

    rows.push(...data)
  }
}
